var shop_currency_default = $('#shop_currency_val').text();

function myCartSection() {
  var SideContentHeight = $('.cart-side-panel .block-cart-header').height();
  //$('#cart_container_id').css('height', $(window).height() - SideContentHeight + 'px'); 
  $('.cart-side-panel .subToggle').css('top', SideContentHeight + 'px'); 
}
jQuery(window).resize(function(){
  myCartSection();
});
var shop_currency;

var wc_theme_source = {
  lib:{
    ajax_error: function(error, message){
      var data = eval('('+error.responseText+')');
      if (!!data.message) {
        $('#added_product_popup').find('h3').text(data.description);
        $('#added_product_popup').find('.cart_redirect_btn').hide();
        $('#added_product_popup').show("clip", 500);
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
          if(cart.item_count > 0){
            var upsell_html = '';
            $.each(cart.items, function(index, item){
              var cart_handle = item.handle;
              var storage_val = localStorage[cart_handle];
              if(typeof storage_val != 'undefined'){
                if(storage_val != ''){
                  upsell_html += storage_val;
                }
              }
              if(index === (cart.items.length - 1)){
                if(upsell_html != ''){
                  $('#wc_cart_drawer_upsell').html(upsell_html);
                } else{
                  $('.upsell_content').attr('style', 'display:none !important;');
                }
              }
            });
          }
          
          $('.cart_qty_cls').html(cart.item_count);
          var shipping_price = parseFloat();
          var total_price = Shopify.formatMoney(cart.total_price, shop_currency_default).replace(/[^\d\.]/g, '');
          var remaining_value = parseFloat(shipping_price) - parseFloat(total_price);
          var final_value = remaining_value.toFixed(2);			
          if( final_value < 0 ){   
            $('.free_shipping').css('display','inline-block');
            $('.notFree_shipping').hide();    
          }
          else{    
            $('.remaining_value').text('$'+final_value);
            $('.notFree_shipping').css('display','inline-block');
            $('.free_shipping').hide();   
          }
          
          if(cart.item_count > 0){
           $('.cart_qty_cls').css('display','block');
            //$('.icon_cart_pro').css('display', 'inline-block');
            
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }
          } else{
            $('.cart_qty_cls').css('display','none');
            //$('.icon_cart_pro').css('display', 'none');
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>$0.00</span>");
            
          }
          setTimeout(function(){
            //currenciesCallbackSpecial('.items_carts span.money');
            myCartSection();
          },1000);
        });
      },100);
    },
    on_item_added: function(item){
      //wc_theme_source.lib.on_cart_update(item);
      ajaxCart.load();
    },
    on_product: function(e){
      alert("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback){
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);
        } else{
          wc_theme_source.lib.on_cart_update(cart);         
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item);
            jQuery('body').toggleClass('CartOpen');
            $('.qty-out-of-stock').hide();
          }
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", false);
          jQuery('#added_product_popup').find('h3').html('<strong>'+ item.title + '</strong> <span>added to your Cart</span>');
          jQuery('#added_product_popup').show("clip", 500);
          return gtag_report_conversion(window.location.href);
        },
        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
            $('.qty-out-of-stock').show();
            setTimeout(function(){ 
              $('.qty-out-of-stock').hide();
            }, 3000);
            
          }
        }
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}

jQuery('.add_to_cart_btn_cls').click(function(){
  /*jQuery('body').toggleClass('CartOpen');*/
  var temp_form_id = jQuery(this).closest('form').attr('id');
  wc_theme_source.lib.addtocart_form(temp_form_id);
  gtag('event', 'Add to cart', {'send_to': 'AW-948971503/aNi4CJWmgesBEO_PwMQD'});
  return false;
});









jQuery('.wishlist_add_btn_cls').click(function(){
  var temp_form_id = jQuery(this).closest('form').attr('id');
  var remove_var = jQuery(this).parents('.cartItem').find('.js-remove-button');
  wc_theme_source.lib.addtocart_form(temp_form_id);
  return false;
});

jQuery('.close_popup_btn_addtocart').click(function(){
  var defalut_text = 'Product added to your Cart';
  jQuery('#added_product_popup').hide();
  setTimeout(function(){
    jQuery('#added_product_popup').find('h3').text(defalut_text);
    jQuery('#added_product_popup').find('.cart_redirect_btn').show();
  },800);
});

jQuery(document).ready(function(){
  ajaxCart.load();
});	

$('#shoppingcart').click(function(){
  if($('body').hasClass('CartOpen')){
    $('.fb_dialog_content iframe').hide();
  }
})

$('.cart-close').click(function(){
  $('.fb_dialog_content iframe').show();
})